import { getData, postData } from '../../../shared/api/core';

export const getStagedVoyages = (portOperatorId, { page, size } = {}) => {
  const params = new URLSearchParams();
  if (portOperatorId) params.set('portOperatorId', portOperatorId);
  if (page != null) params.set('page', page);
  if (size != null) params.set('size', size);
  const query = params.toString();
  return getData(`/staging/voyages${query ? `?${query}` : ''}`);
};

export const getStagedVoyagesCount = (portOperatorId) => {
  const params = portOperatorId ? `?portOperatorId=${portOperatorId}` : '';
  return getData(`/staging/voyages/count${params}`);
};

export const getStagedVoyageCandidates = (stagedId) =>
  getData(`/staging/voyages/${stagedId}/candidates`);

export const getStagedVoyageDiff = (stagedId, manualVoyageId) =>
  getData(`/staging/voyages/${stagedId}/diff/${manualVoyageId}`);

export const confirmStagedMatch = (stagedId, manualVoyageId) =>
  postData(`/staging/voyages/${stagedId}/confirm/${manualVoyageId}`);

export const confirmSelectiveMerge = (stagedId, manualVoyageId, mergeRequest) =>
  postData(
    `/staging/voyages/${stagedId}/confirm-selective/${manualVoyageId}`,
    mergeRequest
  );

export const createStagedAsNew = (stagedId) =>
  postData(`/staging/voyages/${stagedId}/create-new`);

export const rejectStaged = (stagedId) =>
  postData(`/staging/voyages/${stagedId}/reject`);

export const searchVoyagesForStaged = (stagedId, query) =>
  getData(`/staging/voyages/${stagedId}/search?q=${encodeURIComponent(query)}`);
